import { jsxs as g, jsx as e } from "react/jsx-runtime";
import l from "classnames";
const _ = "forma-ui__logo__link", n = "forma-ui__logo__image", r = "forma-ui__logo__imageHover", c = "forma-ui__logo__imageWrap", u = "forma-ui__logo__imageText", p = "forma-ui__logo__button", a = {
  link: _,
  image: n,
  imageHover: r,
  imageWrap: c,
  imageText: u,
  button: p
}, k = (s) => {
  const { as: f = "span", lang: x, text: o, showText: m, className: t, textClassName: N, ...i } = s;
  return /* @__PURE__ */ g("span", { className: l(a.link, t), ...i, children: [
    /* @__PURE__ */ e("div", { className: a.imageWrap, children: /* @__PURE__ */ e(
      "img",
      {
        className: a.image,
        src: "/images/small_logo.svg",
        alt: o
      }
    ) }),
    m && // <ReactSVG
    //   className={classNames(styles.imageText, textClassName)}
    //   src={`/images/title_${lang}.svg`}
    //   wrapper="span"
    // />
    o
  ] });
};
export {
  k as default
};
